// @flow
import * as React from 'react'

export type PropsType = {
  size?: number,
  color?: string
}

export default function SeriesIcon (props: PropsType): React.Node {
  return (
    <svg width={props.size || '100%'} height={props.size || '100%'} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.63286 3.42729H8.28647V2.08091C8.28647 1.87772 8.12246 1.71371 7.91928 1.71371H6.57289V0.367319C6.57289 0.164137 6.40887 0.00012207 6.20569 0.00012207H0.367258C0.164076 0.00012207 6.10352e-05 0.164137 6.10352e-05 0.367319V6.20575C6.10352e-05 6.40894 0.164076 6.57295 0.367258 6.57295H1.71365V7.91934C1.71365 8.12252 1.87766 8.28654 2.08084 8.28654H3.42723V9.63293C3.42723 9.83611 3.59125 10.0001 3.79443 10.0001H9.63286C9.83605 10.0001 10.0001 9.83611 10.0001 9.63293V3.79449C10.0001 3.59131 9.83605 3.42729 9.63286 3.42729ZM0.734455 5.83856V0.734516H5.83849V5.83856H0.734455ZM2.44804 7.55214V6.57295H6.20569C6.40887 6.57295 6.57289 6.40894 6.57289 6.20575V2.4481H7.55208V7.55214H2.44804ZM9.26567 9.26573H4.16163V8.28654H7.91928C8.12246 8.28654 8.28647 8.12252 8.28647 7.91934V4.16169H9.26567V9.26573Z" fill={props.color || '#F6F3F0'} />
    </svg>
  )
}
